import Service from '@ember/service';

class CustomEndpointWrapperService extends Service {
  format(dataToWrap) {
    return {
      data: dataToWrap,
    };
  }
}

export default CustomEndpointWrapperService;
